export default {
    props: {
        renderHtml: {
            type: Function,
            default: () => {}
        },
        scope: {
            type: Object,
            default: () => {}
        }
    },
    render(h) {
        return <div>
            {this.renderHtml(h, this.scope)}
        </div>
    }
}
